import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'pt',
    supportedLngs: ['pt', 'en', 'es', 'fr'],
    debug: false,
    
    // Only load the active language, not fallback
    load: 'currentOnly',
    
    // Namespaces - only preload 'common', others load on demand
    ns: ['common'],
    defaultNS: 'common',
    
    // Lazy load other namespaces when needed
    partialBundledLanguages: true,
    
    // Backend config - load from public folder
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
      // Add cache busting to ensure fresh translations
      queryStringParams: { v: '1.21.0' },
      requestOptions: {
        cache: 'no-cache',
      },
    },
    
    // Detection config
    // URL/explicit choice is the SINGLE source of truth for language (SEO):
    // the visible language is decided ONLY by the ?lng= query param or a
    // previously stored explicit choice (localStorage). Browser-language
    // auto-detection (`navigator`) and `htmlTag` were REMOVED so that any URL
    // WITHOUT ?lng= renders deterministically in PT (the x-default / canonical
    // language) — for humans AND for crawlers (Googlebot has no localStorage,
    // so it always falls back to `pt`). This kills the GSC "duplicate /
    // Google chose a different canonical" noise caused by the same URL serving
    // different languages depending on the visitor's browser.
    detection: {
      order: ['querystring', 'localStorage'],
      lookupQuerystring: 'lng',
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
    
    interpolation: {
      escapeValue: false, // React already escapes
    },
    
    react: {
      useSuspense: true,
    },
  });

export default i18n;
